var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"asc-validation-message theme--light error--text"},[_c('div',{staticClass:"messages__wrapper"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }